module.exports = __webpack_public_path__ + "static/img/7.13ac0f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/7.png
// module id = y/zy
// module chunks = 0